<template>
  <div id="homePage" v-loading="loading">
    <pageTags :selestKey="selestKey" @setSelestKey="setSelestKey"></pageTags>
    <div id="maskAll"></div>
    <div id="contentAll">
      <div class="videoBox" id="continue0">
        <video
          class="video"
          loop
          muted
          autoplay
          :src="require('@/assets/mp/4K钱江新城.mp4')"
        ></video>

        <div class="banner-mouse">
          <img src="../assets/image/up.png" />
        </div>
      </div>
      <div class="banner-demo">
        <div class="banner-demoText">
          <h2 class="banner-demoTitle">使命愿景</h2>
          <div class="banner-demoB">
            <h3 class="banner-domeb-t">使命</h3>
            <div>
              <div>让城市更智能&nbsp;&nbsp;&nbsp;</div>
              <div>让生活更美好&nbsp;&nbsp;&nbsp;</div>
            </div>
          </div>
          <div class="banner-demoB">
            <h3 class="banner-domeb-t">愿景</h3>
            <div>
              <div>成为业内领先的</div>
              <div>智能科技服务商</div>
            </div>
          </div>
        </div>
        <!-- <div class="banner-demoText">敏捷开发·降低成本·高效交付</div> -->
      </div>

      <!-- 软件项目承接 -->
      <div class="bg-grenn" id="continue1">
        <div class="body-item second">
          <label>
            <h3>软件项目承接</h3>
            <h5>SOFTWARE PROJECT SERVICE</h5>
            <p>
              定位于短期内没有产品经理与开发主管的甲方客户，我们根据行业与领域情况安排产品经理进行对接
              按照常规的软件项目签约与管理流程完成软件项目开发与交付
            </p>
          </label>
          <div>
            <ul>
              <li class="tally">
                <div class="svgppp">
                  <img src="../assets/image/lujing.png" class="st1" />
                </div>
                <label>
                  <h3>ERP / OA</h3>
                  <p>企业内部管理系统</p>
                </label>
              </li>
              <li class="cart">
                <div class="svgppp">
                  <img src="../assets/image/gouwucheman.png" class="st1" />
                </div>
                <label>
                  <h3>电商平台</h3>
                  <p>B2C与B2B2C线上商城</p>
                  <p>PC端/小程序端/公众号端</p>
                </label>
              </li>
              <li class="plane">
                <div class="svgppp">
                  <img src="../assets/image/fasong.png" class="st1" />
                </div>

                <label>
                  <h3>扫码点单</h3>
                  <p>餐饮管理系统、扫码点单系统</p>
                  <p>PC端/公众号端/企业微信</p>
                </label>
              </li>
              <li class="video">
                <div class="svgppp">
                  <img src="../assets/image/scene.png" class="st1" />
                </div>

                <label>
                  <h3>在线教育系统</h3>
                  <p>线上授课、直播或录播课程</p>
                  <p>线上报名与在线答题</p>
                </label>
              </li>
              <li class="video">
                <div class="svgppp">
                  <img src="../assets/image/edit.png" class="st1" />
                </div>
                <label>
                  <h3>在线考试系统</h3>
                  <p>在线考试、答题、阅卷系统</p>
                  <p>成绩统计与管理</p>
                </label>
              </li>
            </ul>
            <ul class="bottom">
              <li class="light">
                <div class="svgppp">
                  <img src="../assets/image/lamp.png" class="st1" />
                </div>
                <label>
                  <h3>家装行业</h3>
                  <p>
                    家装厂家管理系统 / 家装经销商管理系统 / 异业联盟平台 /
                    设计师渠道系统
                  </p>
                </label>
              </li>
              <li class="case">
                <div class="svgppp">
                  <img src="../assets/image/industry.png" class="st1" />
                </div>
                <label>
                  <h3>教育行业</h3>
                  <p>职业教育 / 教培行业 / 在线教育 / 在线考试 / 教务管理</p>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 软件开发外包 -->
      <div class="module1" id="continue2">
        <div class="module1-content body-item fist">
          <label>
            <h3>软件开发外包</h3>
            <h5>SOFTWARE DEVELOPMENT SERVICE</h5>
            <p>
              定位于有产品经理或开发主管的甲方客户，提供软件开发、测试、运维层面的技术服务，以人天为计费方式进行结算。可以提供远程服务，也可协商进行短期驻场服务。
            </p>
          </label>
          <ul class="sild-ul">
            <li class="cur flex justify-center align-center flex-column">
              <h3>
                <img src="../assets/image/img6-1.png" />
                <img src="../assets/image/img6-2.png" />
              </h3>
              <h4>后端JAVA开发</h4>
              <div>
                <p>JAVA SpringBoot</p>
                <p>微服务Dobble</p>
                <p>MyAQL/SQLServer/Oracle</p>
                <p>Redis</p>
                <p>Docker/Jenkins</p>
                <p>Vue/小程序/React/Jquery</p>
              </div>
            </li>
            <li class="cur flex justify-center align-center flex-column">
              <h3>
                <img src="../assets/image/img7-1.png" />
                <img src="../assets/image/img7-2.png" />
              </h3>
              <h4>前端Vue/小程序开发</h4>
              <div>
                <p>HTML / HTML5</p>
                <p>CSS / CSS3</p>
                <p>Javascript / JS 6</p>
                <p>Vue</p>
                <p>微信小程序</p>
                <p>ReactJS / ReactNative</p>
              </div>
            </li>
            <li class="cur flex justify-center align-center flex-column">
              <h3>
                <img src="../assets/image/img8-1.png" />
                <img src="../assets/image/img8-2.png" />
              </h3>
              <h4>产品经理</h4>
              <div>
                <p>行业理解力</p>
                <p>用户角色导向</p>
                <p>《功能清单》</p>
                <p>原型图Axure</p>
                <p>资深开发出身 / 数据库设计</p>
                <p>开发任务安排</p>
              </div>
            </li>
            <li class="cur flex justify-center align-center flex-column">
              <h3>
                <img src="../assets/image/img9-1.png" />
                <img src="../assets/image/img9-2.png" />
              </h3>

              <h4>测试</h4>
              <div>
                <p>测试软件缺陷/安全性</p>
                <p>测试软件稳定性/易操作性</p>
                <p>编写规范的测试用例</p>
                <p>软件整体质量评估</p>
              </div>
            </li>
            <li class="cur flex justify-center align-center flex-column">
              <h3>
                <img src="../assets/image/img10-1.png" />
                <img src="../assets/image/img10-2.png" />
              </h3>

              <h4>实施运维</h4>
              <div>
                <p>系统监测/故障处理</p>
                <p>系统配置管理</p>
                <p>安全管理</p>
                <p>性能优化和容量规划</p>
                <p>资产管理</p>
                <p>客户服务和沟通协调</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 服务流程 -->
      <div class="bg-grenn">
        <div class="serviceProcess">
          <div class="module1-content body-item">
            <label>
              <h3>服务流程</h3>
              <h5>Service Process</h5>
              <p>
                精准把握每一个开发节点，按时按质完成每一个项目，坚决抵制拖拉和烂尾。
              </p>
            </label>

            <img src="../assets/image/serviceProcess.png" class="banner" />
          </div>
        </div>
      </div>
      <!-- 自营产品 -->
      <div class="bg-orange" id="continue3">
        <div class="body-item product">
          <label>
            <h3>自营产品</h3>
            <h5>PRODUCT</h5>
          </label>
          <ul>
            <li>
              <h3>自研ERP</h3>
              <div>
                <p>面向软件行业开发主管的产品</p>
                <p>任务分派、工时管控、成本管控</p>
                <p>提供开发人员任务与工时管控解决方案</p>
              </div>
              <a
                target="_blank"
                href="http://erptest.ohdt.top?redirect=noRedirect&type=1"
                >访问官网</a
              >
            </li>
            <li>
              <h3>扫码点餐</h3>
              <div>
                <p>多商户SaaS版扫码点餐系统</p>
                <p>后台点餐、多人同时在线点餐、购物车共享</p>
                <p>餐桌状态监控、餐桌管理等众多功能</p>
              </div>
              <a
                target="_blank"
                href="http://scan.ohdt.top/login?redirect=/&type=1"
                >访问官网</a
              >
            </li>
            <li>
              <h3>压力容器监管大屏</h3>
              <div>
                <p>面向特种设备监管部门</p>
                <p>人机交互、多源数据融合、态势展示</p>
                <p>监测指挥和数据可视化分析等多种功能</p>
              </div>

              <a target="_blank" href="../static/largeScreen/index.html"
                >访问官网</a
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- 关于我们 -->
      <div class="aboutUs" id="continue4">
        <div class="aboutUs-content body-item">
          <h4>关于我们</h4>
          <h5>About Us</h5>
          <el-row class="aboutUs-row" :gutter="40">
            <el-col :span="12">
              <p>
                鸥航数字科技有限公司是一家数字化解决方案资深服务商，提供数字化解决方案为主营方向的网站建设、微信小程序开发、软件定制开发、企业内部管理系统、协同办公系统、软件开发外包等服务。
              </p>
              <p>
                鸥航数字科技有限公司核心员工拥有经验丰富的信息处理软件产品开发及相关网站运作经验。公司以“技术创新，服务社会”为经营理念，致力于为中小企业客户提供软件定制开发及相关技术服务，以帮助客户公司提高公司运作效率和竞争力，助力企业数字化转型升级。公司拥有高效、专业、敬业的团队，在这个团队里，有十年以上软件行业经验的开发工程师。公司坚持“以人为本”的经营理念，倡导员工与公司共同成长。
              </p>
            </el-col>
            <el-col :span="12">
              <img src="../assets/image/aboutUs1.jpg" class="aboutUs-img" />
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 联系我们 -->
      <div class="contactUs" id="continue5">
        <label style="width: 100%">
          <div style="width: 1200px; margin: 0 auto; position: relative">
            <h3>联系我们</h3>

            <div class="contactUs-text">
              鸥航致力于为企、事业单位提供一站式的数字化解决方案，追求客户感知与技术服务的完美体验，助力企业数字化转型升级。
            </div>
            <div class="contactUs-btn" @click="cooperation()">开启合作</div>

            <!-- 表单 -->
            <div class="ruleForm" v-if="cooperationShow">
              <div class="ruleForm-close" @click="ruleFormClose">
                <i class="el-icon-close"></i>
              </div>
              <el-form :rules="rules" ref="ruleForm" :model="ruleForm">
                <el-form-item prop="demandType">
                  <el-select
                    v-model="ruleForm.demandType"
                    placeholder="请选择您的需求类型"
                    @blur="refresh()"
                  >
                    <template #prefix>
                      <i class="custom-prefix-icon el-icon-document-copy"></i>
                    </template>
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="companyName">
                  <el-input
                    v-model="ruleForm.companyName"
                    placeholder="请输入您的企业名称"
                    @input="refresh()"
                  >
                    <template #prefix>
                      <i class="custom-prefix-icon el-icon-office-building"></i>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="cityName">
                  <el-input
                    v-model="ruleForm.cityName"
                    placeholder="请输入需求所在的城市"
                    @input="refresh()"
                  >
                    <template #prefix>
                      <i class="custom-prefix-icon el-icon-map-location"></i>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="name">
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入您的姓名"
                    @input="refresh()"
                  >
                    <template #prefix>
                      <i class="custom-prefix-icon el-icon-user-solid"></i>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="phoneNumber">
                  <el-input
                    v-model="ruleForm.phoneNumber"
                    placeholder="请输入您的手机号"
                    @input="refresh()"
                  >
                    <template #prefix>
                      <i class="custom-prefix-icon el-icon-mobile-phone"></i>
                    </template>
                  </el-input>
                </el-form-item>
                <el-button
                  type="primary"
                  style="width: 400px; background: #6085ed; line-height: 2"
                  @click="submitted()"
                  >提交需求</el-button
                >
              </el-form>
            </div>
          </div>
        </label>
        <!-- 移动端表单 -->
        <div class="mobileSide">
          <h3>需求</h3>
          <h5>DEMAND</h5>
          <p>只需要您提供应用场景与需求，我们就可以给出解决方案与开发方案</p>
          <el-form :rules="rules" ref="ruleForm" :model="ruleForm">
            <el-form-item prop="demandType">
              <el-select
                v-model="ruleForm.demandType"
                placeholder="请选择您的需求类型"
                @blur="refresh()"
              >
                <template #prefix>
                  <i class="custom-prefix-icon el-icon-document-copy"></i>
                </template>
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="companyName">
              <el-input
                v-model="ruleForm.companyName"
                placeholder="请输入您的企业名称"
                @input="refresh()"
              >
                <template #prefix>
                  <i class="custom-prefix-icon el-icon-office-building"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="cityName">
              <el-input
                v-model="ruleForm.cityName"
                placeholder="请输入需求所在的城市"
                @input="refresh()"
              >
                <template #prefix>
                  <i class="custom-prefix-icon el-icon-map-location"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入您的姓名"
                @input="refresh()"
              >
                <template #prefix>
                  <i class="custom-prefix-icon el-icon-user-solid"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="phoneNumber">
              <el-input
                v-model="ruleForm.phoneNumber"
                placeholder="请输入您的手机号"
                @input="refresh()"
              >
                <template #prefix>
                  <i class="custom-prefix-icon el-icon-mobile-phone"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-button
              type="primary"
              style="width: 100%; background: #6085ed; line-height: 2"
              @click="submitted()"
              >一键提交需求</el-button
            >
          </el-form>
        </div>
      </div>
      <!-- 地图 -->
      <div>
        <div
          class="headquarters__map wow fadeIn animated"
          style="visibility: visible; width: 100vw; height: 500px"
        >
          <div class="mask"></div>
          <div
            class="app-map-container map wow fadeInUp"
            data-wow-delay="0.8s"
            style="height: 500px; visibility: visible; animation-delay: 0.8s"
          >
            <div id="container" style="width: 100%; height: 500px"></div>
          </div>
        </div>
      </div>

      <leafFoot></leafFoot>
    </div>
  </div>
</template>

<script>
import "@/assets/css/homePage.scss";
import pageTags from "./topTags/pageTags";
import leafFoot from "./leafFoot/index";
import AMapLoader from "@amap/amap-jsapi-loader";
import { selestType, onyhUserDemand } from "../request/api";
export default {
  name: "homePage",
  components: {
    pageTags,
    leafFoot,
  },
  data() {
    return {
      cooperationShow: false,
      loading: false,
      dialogVisible: true,
      mapAddress: null,
      showsearchResult: false,
      poiList: [],
      // locationData: [117.301416, 31.697778],
      locationData: [117.300069, 31.829087],
      ruleForm: {},
      selestKey: 0,
      options: [
        {
          value: "1",
          label: "软件项目承接",
        },
        {
          value: "2",
          label: "软件开发外包",
        },
      ],
      rules: {
        demandType: [
          {
            required: true,
            message: "请选择您的需求类型",
            trigger: ["change", "blur"],
          },
        ],
        companyName: [
          { required: true, message: "请输入您的公司名称", trigger: "blur" },
        ],
        cityName: [
          {
            required: true,
            message: "请输入需求所在城市",
            trigger: ["change", "blur"],
          },
        ],
        name: [{ required: true, message: "请输入您的名称", trigger: "blur" }],
        phoneNumber: [
          { required: true, message: "请输入您的手机号码", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // 地图
    window._AMapSecurityConfig = {
      securityJsCode: "b0e5fd895c0d8cfa0b4a146b21ea987c", //你的秘钥
    };
    this.initMap();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    // 销毁地图，并清空地图容器.该方法执行后，地图对象被注销，内存释放，地图容器被清空。
    this.map.destroy();
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // 平滑滚动
    });
  },
  methods: {
    refresh() {
      this.$forceUpdate();
    },
    handleScroll() {
      var scrollY = window.scrollY;

      if (scrollY > 15) {
        document.getElementById("pageTags").style.background = "#132b56";
      } else {
        document.getElementById("pageTags").style.background = "";
      }
      if (window.innerWidth > 780) {
        if (scrollY <= 500) {
          this.selestKey = 0;
        }
        if (scrollY >= 500) {
          this.selestKey = 1;
        }
        if (scrollY >= 1200) {
          this.selestKey = 2;
        }
        if (scrollY >= 2000) {
          this.selestKey = null;
        }
        if (scrollY >= 3000) {
          this.selestKey = 3;
        }
        if (scrollY >= 3900) {
          this.selestKey = 4;
        }
        if (scrollY >= 4600) {
          this.selestKey = 5;
        }
      }
    },
    handleClose() {
      this.$emit("handleClose");
    },
    initMap() {
      AMapLoader.load({
        key: "f7025a4e85cd8dd66b0ccdef70b6d1b2", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        resizeEnable: true,
      })
        .then((AMap) => {
          const that = this;
          that.map = new AMap.Map("container", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 15, //初始化地图级别
            center: this.locationData,
            title: "安徽省合肥市包河区汇鑫大厦A座1013",
          });
          // 点标记显示内容，HTML要素字符串
          // var markerContent =
          //   "" +
          //   '<div class="custom-content-marker">' +
          //   ' <img src="//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png">' +
          //   '   <div class="close-btn" >安徽省合肥市包河区汇鑫大厦A座1013</div>' +
          //   "</div>";
          var markerContent =
            "" +
            '<div class="custom-content-marker">' +
            '   <div class="close-btn" ><div class="close-title">欧航数字科技</div><div>地址：安徽省合肥市包河区</div><div style="margin-left:35px">汇鑫大厦A座1013</div><div>电话：18010880865</div></div>' +
            "</div>";
          var marker = new AMap.Marker({
            position: new AMap.LngLat(
              this.locationData[0],
              this.locationData[1]
            ),
            content: markerContent,
            offset: new AMap.Pixel(-13, -30),
            title: "安徽省合肥市包河区汇鑫大厦A座1013",
          });
          // that.map.setCity("安徽省合肥市包河区汇鑫大厦A座1013");
          that.map.add(marker);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    submitted() {
      console.info("提交");
      this.$refs["ruleForm"].validate((valid) => {
        console.info(valid);
        if (valid) {
          this.loading = true;
          onyhUserDemand(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["ruleForm"].resetFields();
            } else {
              this.$message.error(res.msg ? res.msg : "提交失败请稍后再试");
            }
            this.loading = false;
          });
        }
      });
    },
    cooperation() {
      this.cooperationShow = !this.cooperationShow;
    },
    ruleFormClose() {
      this.$refs["ruleForm"].resetFields();
      this.cooperationShow = false;
    },
    setSelestKey(key) {
      this.selestKey = key;
    },
  },
};
// <style lang="scss">
// </style>
</script>
 <style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/homePage.vue